<template>
  <div class="ldar">
    <div class="container">
      <h1>LDAR检测</h1>
      <p class="subtitle">泄漏检测与修复解决方案</p>
      
      <div class="ldar-section">
        <h2 class="section-title">我们的设备</h2>
        <div class="service-list devices-grid">
          <router-link to="/ldar/device-1" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/11.jpg')" alt="讯飞声学成像仪" />
            </div>
            <div class="service-content">
              <h3>讯飞声学成像仪</h3>
              <p>讯飞声学成像仪利用超声定位、声像叠加技术与独特算法、快速准确地找到泄漏源，提升检测速度和效率。</p>
            </div>
          </router-link>
          <router-link to="/ldar/device-2" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/15.png')" alt="Model 115 FID 便携式VOCs分析仪" />
            </div>
            <div class="service-content">
              <h3>Model 115 FID 便携式VOCs分析仪</h3>
              <p>Model115便携式VOCs分析仪采用FID检测器，检测器使用氢气和助燃气产生氢火焰，当有机化合物进入到燃烧火焰时会被离子化。离子化产生的自由电子束通过探测器中的极化电极被直接送到检测电路中</p>
            </div>
          </router-link>
          <router-link to="/ldar/device-3" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/16.jpg')" alt="TVA2020C（FID+PID)双模有毒气体分析仪" />
            </div>
            <div class="service-content">
              <h3>TVA2020C（FID+PID)双模有毒气体分析仪</h3>
              <p>TVA2020C 有毒挥发气体分析仪具备同时检测有机和无机化合物的能力。 TVA2020C分析仪广泛应用于包括遵循美国EPA方法21监测的现场、现场修复检测、垃圾填埋环境监测、以及常规的区域环境调查。</p>
            </div>
          </router-link>
          <router-link to="/ldar/device-4" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/17.jpg')" alt="LDAR系列手操器" />
            </div>
            <div class="service-content">
              <h3>LDAR系列手操器</h3>
              <p>手持式移动数据采集器（手操器） 是一台基于Andriod研发的具备在高危作业环境下的高性能设备。其内置有先进的LDAR图像及数据采集处理软件，具备拍照、图片点位标注、及相关数据信息录采集录入等功能。</p>
            </div>
          </router-link>
          <router-link to="/ldar/device-5" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/18.jpg')" alt="长波型红外气体检漏成像仪" />
            </div>
            <div class="service-content">
              <h3>长波型红外气体检漏成像仪</h3>
              <p>主要特点 此设备属长波型红外气体检漏成像仪，大大增加了可探波长范围和可探气体种类。</p>
            </div>
          </router-link>
          <router-link to="/ldar/device-6" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/19.jpg')" alt="EyeCGas红外气体检漏成像仪" />
            </div>
            <div class="service-content">
              <h3>EyeCGas红外气体检漏成像仪</h3>
              <p>主要特点: 1、专为工业领域设计——适用于工业废气、有机化合物、有毒气体排放的工况，该红外气体成像仪坚固耐用，密封性良好，适合在户外工况下使用。</p>
            </div>
          </router-link>
        </div>
      </div>

      <div class="ldar-section">
        <h2 class="section-title">解决方案</h2>
        <div class="service-list">
          <router-link to="/ldar/solution-1" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/19.png')" alt="LDAR检测服务实施流程" />
            </div>
            <div class="service-content">
              <h3>LDAR检测服务实施流程</h3>
            </div>
          </router-link>
          <router-link to="/ldar/solution-2" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/20.jpg')" alt="红外气体成像检测服务（OGI）" />
            </div>
            <div class="service-content">
              <h3>红外气体成像检测服务（OGI）</h3>
            </div>
          </router-link>
          <router-link to="/ldar/solution-3" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/21.jpg')" alt="声学成像检测解决方案" />
            </div>
            <div class="service-content">
              <h3>声学成像检测解决方案</h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLdar'
}
</script>

<style scoped>
.ldar {
  padding: 80px 0;
  background: linear-gradient(135deg, #f9f9f9 0%, #e6f3ee 100%);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

 h1 {
  font-size: 36px;
  margin-bottom: 15px;
  color: #333;
  text-align: center;
}

.subtitle {
  text-align: center;
  font-size: 18px;
  color: #666;
  margin-bottom: 60px;
}

@media screen and (max-width: 768px) {
  .ldar {
    padding: 60px 0;
  }

  h1 {
    font-size: 28px;
  }

  .subtitle {
    font-size: 16px;
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 480px) {
  .ldar {
    padding: 40px 0;
  }

  h1 {
    font-size: 24px;
  }

  .subtitle {
    font-size: 14px;
    margin-bottom: 30px;
  }
}

.ldar-section {
  margin-bottom: 80px;
}

.section-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 3px solid #42b983;
}

@media screen and (max-width: 768px) {
  .ldar-section {
    margin-bottom: 60px;
  }

  .section-title {
    font-size: 24px;
  }
}

@media screen and (max-width: 480px) {
  .ldar-section {
    margin-bottom: 40px;
  }

  .section-title {
    font-size: 20px;
  }
}

.service-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.devices-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.service-item {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: block;
  text-decoration: none;
  color: inherit;
}

.service-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.service-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.service-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
  background-color: #f9f9f9;
}

.service-item:hover .service-image img {
  transform: scale(1.1);
}

.service-content {
  padding: 25px;
}

.service-content h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 12px;
}

.service-content p {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
}

@media screen and (max-width: 768px) {
  .service-list {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }

  .service-image {
    height: 180px;
  }

  .service-content {
    padding: 20px;
  }

  .service-content h3 {
    font-size: 18px;
  }

  .service-content p {
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  .service-list {
    grid-template-columns: 1fr;
  }

  .service-image {
    height: 160px;
  }

  .service-content {
    padding: 15px;
  }

  .service-content h3 {
    font-size: 16px;
  }

  .service-content p {
    font-size: 13px;
  }
}
</style>